<template>
  <app-content class="h-panel">
    <div class="h-panel-bar"><span class="h-panel-title">核对总账</span></div>
    <Row type="flex" :space-x="10" class="margin-right-left margin-top">
      <Cell>
        <DatePicker v-model="date" :clearable="false" format="YYYY-MM-DD" style="width: 160px;"></DatePicker>
      </Cell>
      <Cell>
        <Button color="primary" icon="fa fa-search" :loading="loading" @click="loadList">查询</Button>
        <Button icon="fa fa-refresh" :loading="loading" @click="loadList">刷新</Button>
        <Button icon="fa fa-print" @click="doPrint">打印</Button>
        <Button @click="doExport">导出</Button>
      </Cell>
    </Row>
    <div class="h-panel-body" style="overflow-x: auto;">
      <table class="check-table">
        <thead>
        <tr>
          <th>项目</th>
          <th>名称</th>
          <th>币别</th>
          <th>期初余额</th>
          <th>借方(收入)</th>
          <th>贷方(支出)</th>
          <th>余额</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in dataList" :key="index">
          <td align="center">{{ item.subjectCode || item.accountId }}</td>
          <td>{{ item.subjectName || item.accountName }}</td>
          <td align="center">{{ item.currency || '人民币' }}</td>
          <td align="right">{{ item.opening | numFormat }}</td>
          <td align="right">{{ item.debitAmount | numFormat }}</td>
          <td align="right">{{ item.creditAmount | numFormat }}</td>
          <td align="right">{{ item.ending | numFormat }}</td>
        </tr>
        <tr v-if="!dataList.length">
          <td colspan="7" class="text-center padding">暂无数据</td>
        </tr>
        </tbody>
      </table>
    </div>
  </app-content>
</template>

<script>
import moment from 'moment';
import {exportCsv} from '../../js/common/export-file';

export default {
  name: 'CheckUp',
  data() {
    return {
      date: moment().format('YYYY-MM-DD'),
      dataList: [],
      loading: false
    }
  },
  methods: {
    loadList() {
      this.loading = true;
      this.$api.funds.checkGeneral({date: this.date}).then(({data}) => {
        this.dataList = data.results || data || [];
      }).catch(() => {
        this.$Message.error('核对总账数据加载失败');
      }).finally(() => this.loading = false);
    },
    doPrint() {
      window.print();
    },
    doExport() {
      let headers = ['项目', '名称', '币别', '期初余额', '借方(收入)', '贷方(支出)', '余额'];
      let rows = this.dataList.map(item => [
        item.subjectCode || item.accountId, item.subjectName || item.accountName, item.currency || '人民币', item.opening, item.debitAmount, item.creditAmount, item.ending
      ]);
      exportCsv('核对总账', headers, rows);
    }
  },
  mounted() {
    this.loadList();
  }
}
</script>

<style lang="less" scoped>
.check-table {
  width: 100%;
  border-collapse: collapse;

  th, td {
    padding: 8px 10px;
    border: 1px solid #e2e2e2;
    font-size: 13px;
  }

  th {
    background: #f5f5f5;
    text-align: center;
  }

  tbody tr:nth-child(even) {
    background: #fafafa;
  }
}
</style>
